module.exports = __webpack_public_path__ + "datadog.3cb8ca.svg";